import { render, staticRenderFns } from "./MsrbDetail.vue?vue&type=template&id=187c8a75&"
import script from "./MsrbDetail.vue?vue&type=script&lang=js&"
export * from "./MsrbDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports